/**
 * @generated SignedSource<<40ee9c2e0043418bace38de1eec28a29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CloudStorageProvider = "GOOGLE_DRIVE" | "ONEDRIVE" | "%future added value";
export type CreateClientAssetInput = {
  projectId: string;
  assetType: string;
  name: string;
  note?: string | null;
  taskId?: string | null;
  closureMode?: string | null;
  requiresReadAck?: boolean | null;
  requestedFromPortalUserId?: string | null;
  approverPortalUserId?: string | null;
  dueDate?: string | null;
  storageKey?: string | null;
  fileName?: string | null;
  sizeBytes?: number | null;
  cloudLink?: ClientAssetCloudLinkInput | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ClientAssetCloudLinkInput = {
  provider: CloudStorageProvider;
  externalFileId: string;
};
export type clientAssetMutationsCreateMutation$variables = {
  input: CreateClientAssetInput;
};
export type clientAssetMutationsCreateMutation$data = {
  readonly createClientAsset: {
    readonly asset: {
      readonly id: string;
      readonly status: string;
    } | null;
  } | null;
};
export type clientAssetMutationsCreateMutation = {
  variables: clientAssetMutationsCreateMutation$variables;
  response: clientAssetMutationsCreateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateClientAssetPayload",
    "kind": "LinkedField",
    "name": "createClientAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientAsset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clientAssetMutationsCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "clientAssetMutationsCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e6cfd0c732998a333e4599ea55e0b040",
    "id": null,
    "metadata": {},
    "name": "clientAssetMutationsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation clientAssetMutationsCreateMutation(\n  $input: CreateClientAssetInput!\n) {\n  createClientAsset(input: $input) {\n    asset {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "09d1d74bd527a6d6f79952d76eeb49aa";

export default node;
